<button type="button" class="de-primary-btn w-100" (click)="orderNow()">
  <ng-container *ngIf="!orderNowLoading">
    Order Now
  </ng-container>
  <ng-container *ngIf="orderNowLoading">
    <div class="de-btn-loader"></div>
  </ng-container>
</button>
